<template>
  <li class="list-item">
    <a
      class="list-item__container"
      href="#drawer-messages-chat"
      data-toggle="drawer"
      aria-foldedopen="false"
      aria-controls="drawer-messages-chat"
      @click="handleGetThreadCallback"
      :class="notificationClass"
    >
      <div class="list-item__participants participants-container flex-shrink-0 m-r-xs">
        <img v-for="p in participantsAvatars" :key="p.id" :src="p.avatar" :alt="p.name" />
      </div>
      <div class="list-item__content">
        <div class="list-item__header">
          <h3 class="list-item__title">
            {{ booking.name }}
          </h3>
          <span v-if="this.thread.unread_count && $userIsAdmin" class="list-item__bids">
            {{ this.thread.unread_count }}
          </span>
        </div>

         <meta-item :label="false" :full-width="true">
          {{ participantsNames }}
        </meta-item>

        <div class="list-item__status spacer-y-2">
          <span class="label label-danger" v-if="bookingIsContextuallyCancelled">Cancelled</span>
          <span class="label label-success" v-else-if="bookingIsScheduled">Scheduled</span>
          <span class="label label-info" v-else-if="bookingIsOnHold">On Hold</span>
          <span class="label label-success" v-else-if="bookingIsBooked">Booked</span>
          <span class="label label-success" v-else-if="bookingIsCompleted">Completed</span>
          <span class="label label-hidden" v-if="$userIsAdmin && bookingIsNotPublic">Hidden</span>
          <span class="label label-danger" v-if="$paymentsModuleEnabled && bookingBookedDepositUnpaid">Deposit Unpaid</span>
          <span class="label label-danger" v-if="$paymentsModuleEnabled && bookingBookedDepositSent">Deposit Sent</span>
        </div>

        <div class="list-item__chat chat-item">
          <div
            v-if="thread.latest_message"
            class="chat-item__message"
            :class="{
              'chat-item__message--unread': this.thread.unread_count && $userIsAdmin
            }"
          >
            <div class="chat-item__body">{{ thread.latest_message.file ? 'File Uploaded' : thread.latest_message.text }}</div>
            <div class="chat-item__meta flex flex-wrap w-full items-baseline">
              <div class="chat-item__name">{{ messageName }}</div>
              <div class="chat-item__time">{{ messageTimestamp }}</div>
            </div>
          </div>
          <template v-else>
            <span>No Messages</span>
          </template>
        </div>
      </div>

      <div class="list-item__values" >
        <div class="list-item__budget" v-if="$costReferences" >
          <template v-if="$userIsTalent || $userIsManager && monetaryCurrency">
            {{ booking.budget_per_star_as_user_rate | currency(booking.currency) | nullable }}
            <template v-if="$userIsManager">
              / {{ $starLabel }}
            </template>
          </template>
          <template v-else>
            <span>{{ booking.budget_per_star | currency(booking.currency) }}</span>
            <template v-if="$userIsAdmin && monetaryCurrency">
              ({{ booking.budget_per_star_as_user_rate | currency(booking.currency) }})
            </template>
            / {{ $starLabel }}
          </template>
        </div>

        <div v-if="$userIsAdmin" class="list-item__admin list-item__admin--left-aligned">
          <template v-if="$paymentsModuleEnabled">
            <meta-item v-if="bookingStateOrOnline" icon="globe" :label="false" :full-width="true">
              {{ bookingStateOrOnline }}
            </meta-item>
            <meta-item v-if="bookingAppearanceInPerson" icon="calendar" :label="false" :full-width="true">
              {{ booking.tz_date | dateTimezone(booking.timezone, $user.date_format_preference) | nullable }}
            </meta-item>
            <meta-item v-else icon="calendar" :label="false" :full-width="true">
               &ndash;
            </meta-item>
          </template>
          <meta-item v-if="bookingIsNotPublic" icon="eye-slash">Hidden</meta-item>
          <meta-item :full-width="true">
            <template v-slot:key>Booking ID:</template>
            {{ booking.id }}
          </meta-item>
          <template v-if="booking.payments.length > 0">
            <meta-item v-for="payment in booking.payments" :key="payment.id">
              <template v-slot:key>{{ payment.type }}:</template>
              {{payment.status }}
            </meta-item>
          </template>
        </div>
      </div>
    </a>
    <button
      v-if="$userIsAdmin"
      class="list-item__pin"
      :class="{
        'list-item__pin--pinned': thread.pinned,
      }"
      @click="handlePinThreadCallback">
      <i class="fa fa-thumb-tack"></i>
    </button>
  </li>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { helpers } from 'mixins/messages'
import { helpers as bookingHelpers } from 'mixins/bookings'
import MetaItem from '../list/meta/MetaItem'
import { ChatTracker } from 'mixins/analytics'

export default {
  mixins: [helpers, bookingHelpers, ChatTracker],
  components: {
    MetaItem
  },
  props: {
    thread: {
      required: true,
      type: Object
    },
    booking: {
      required: true,
      type: Object
    }
  },

  computed: {
    ...mapState('clientConfig', ['client_config']),
    notificationClass () {
      if (this.thread.active) {
        return 'active'
      }
      return 'inactive'
    }
  },
  methods: {
    ...mapActions('message', ['getThread', 'pinThread', 'unpinThread']),

    handleGetThreadCallback () {
      this.trackEvent(this.analytics.V2.ChatListingClickEvent)
      const targetElement = document.getElementById('mainbody')
      targetElement.style.overflow = 'hidden'
      return this.getThread({threadId: this.thread.id, userId: this.$user.id, tenantSlug: this.client_config.slug, getFiles: true})
    },

    handlePinThreadCallback () {
      return this.thread.pinned
        ? this.unpinThread({ threadId: this.thread.id })
        : this.pinThread({ threadId: this.thread.id })
    }
  }
}
</script>
